import { ShippingType } from "./broadcast.interface";
import { IDetailOrder, IDetailTodo } from "./live.interface";

export type OrderStatus =
  | "REQUEST" // 신규 주문
  | "DEPOSIT_WAIT" // 입금 대기
  | "COMPLETE" // 결제 완료
  | "DELIVERY_READY" // 배송 준비
  | "DELIVERY" // 배송 완료
  | "CANCEL" // 주문 취소
  | "REFUND_HOLD_CANCEL" // 환불 보류 - 취소
  | "REFUND_HOLD_RETURN" // 환불 보류 - 반품
  | "REFUND"; // 환불 완료

export type OrderStatusWithTotal = OrderStatus | "TOTAL";

export const OrderStatusChangeKr = (e: OrderStatusWithTotal) => {
  let _ = e as string;
  if (e === "REQUEST") _ = "ORDER";
  switch (_) {
    case "ORDER":
      return "신규주문";
    case "DEPOSIT_WAIT":
      return "입금대기";
    case "COMPLETE":
    case "DEPOSIT":
      return "결제완료";

    case "DELIVERY_READY":
      return "배송준비";
    case "DELIVERY":
      return "배송완료";
    case "CANCEL":
      return "주문취소";
    case "REFUND_HOLD_CANCEL":
      return "환불보류";
    case "REFUND_HOLD_RETURN":
      return "환불보류";
    case "REFUND":
      return "환불완료";
    case "TOTAL":
      return "전체";
    default:
      return e;
  }
};
export interface OrderStatistics {
  orderPlacedCount: number;
  paymentConfirmedCount: number;
  deliveryReadyCompletedCount: number;
  deliveryCompletedCount: number;
  orderCancelledCount: number;
  orderRefundedCount: number;
  depositWaitCount: number;
  refundHoldCancelCount: number;
  refundHoldReturnCount: number;
  totalOrderCount: number;

  orderPlacedPeopleCount: number;
  paymentConfirmedPeopleCount: number;
  deliveryReadyPeopleCount: number;
  deliveryCompletedPeopleCount: number;
  orderCancelledPeopleCount: number;
  orderRefundedPeopleCount: number;
  depositWaitPeopleCount: number;
  refundHoldCancelPeopleCount: number;
  refundHoldReturnPeopleCount: number;
  totalPeopleCount: number;
}

export interface OrderSummary {
  REQUEST: { count: number; peopleCount: number };
  DEPOSIT_WAIT: { count: number; peopleCount: number };
  COMPLETE: { count: number; peopleCount: number };
  DELIVERY_READY: { count: number; peopleCount: number };
  DELIVERY: { count: number; peopleCount: number };
  CANCEL: { count: number; peopleCount: number };
  REFUND_HOLD_CANCEL: { count: number; peopleCount: number };
  REFUND_HOLD_RETURN: { count: number; peopleCount: number };
  REFUND: { count: number; peopleCount: number };
  TOTAL: { count: number; peopleCount: number };
}

//  "default" | "orderCode" | "productName" | "memo"
export enum SearchTypeEnum {
  주문자정보 = "default",
  주문코드 = "orderCode",
  상품명 = "productName",
  메모 = "memo",
}
export interface SearchFormData {
  searchType: SearchTypeEnum;
  searchWord?: string;
}

export type OrderListHeader =
  | "체크박스"
  | "주문번호"
  | "주문자 닉네임"
  | "주문일시"
  | "주문상태"
  | "상태변경일시"
  | "결제완료일시"
  | "배송준비일시"
  | "배송완료일시"
  | "주문취소일시"
  | "취소접수일시"
  | "취소처리"
  | "취소사유"
  | "취소상세사유"
  | "취소/반품완료일시"
  | "환불방식"
  | "환불유형"
  | "환불사유"
  | "환불상세사유"
  | "실환불금액"
  | "실결제금액"
  | "최종결제금액"
  | "상품명"
  | "상품번호"
  | "옵션"
  | "수량"
  | "판매가"
  | "상품금액"
  | "총상품금액"
  | "배송비"
  | "제주/도서산간 배송비"
  | "추가배송비"
  | "반품배송비"
  | "결제수단"
  | "수령인이름"
  | "수령인연락처"
  | "기본주소"
  | "상세주소"
  | "우편번호"
  | "송장번호"
  | "주문자연락처"
  | "요청사항"
  | "판매자 메모";

export type EditActionType =
  | "editOption"
  | "editQuantity"
  | "editAddress"
  | "editTracking"
  | "editMemo"
  | "cancel-start"
  | "refund-complete"
  | "checkbox-user-add"
  | "checkbox-user-remove"
  | "checkbox-user-all"
  | "checkbox-user-all-remove"
  | "checkbox-item-add"
  | "checkbox-item-remove"
  | "checkbox-item-add-group"
  | "checkbox-item-remove-group"
  | "address-history";

export interface StatusTableProps {
  broadcastId: string;
  status: OrderStatusWithTotal;
  data?: IDetailTodo[];
  shippingInfo: {
    shippingCharge: number | null;
    shippingPurchaseAmount: number | null;
    shippingType: ShippingType;
    jejuShippingCharge: number | null;
    remoteAreaShippingCharge: number | null;
  };
  scrollRef: React.RefObject<HTMLDivElement>;
  selectedOrders: Number[];
  handleScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  handleRowAction: (
    action: EditActionType,
    data: IDetailTodo | IDetailOrder
  ) => void;
  isAllSelected: boolean;
}

export enum CancelReasonCode {
  BUYER_CHANGE_OF_MIND = "BUYER_CHANGE_OF_MIND", // 구매자 변심
  BUYER_ORDER_MISTAKE = "BUYER_ORDER_MISTAKE", // 구매자 주문 실수
  OUT_OF_STOCK = "OUT_OF_STOCK", // 재고 부족
  PRODUCT_DAMAGE_OR_DEFECT = "PRODUCT_DAMAGE_OR_DEFECT", // 상품 손상 또는 결함
  WRONG_DELIVERY = "WRONG_DELIVERY", // 오배송
  SELLER_CANCELLATION = "SELLER_CANCELLATION", // 판매자 취소
}
export const CancelReasonCodeKr = (codeKr: string) => {
  switch (codeKr) {
    case "구매자 단순변심":
      return CancelReasonCode.BUYER_CHANGE_OF_MIND;
    case "구매자 주문실수":
      return CancelReasonCode.BUYER_ORDER_MISTAKE;
    case "재고 부족":
      return CancelReasonCode.OUT_OF_STOCK;
    case "상품 파손 및 불량":
      return CancelReasonCode.PRODUCT_DAMAGE_OR_DEFECT;
    case "오배송":
      return CancelReasonCode.WRONG_DELIVERY;
    case "판매자 취소":
      return CancelReasonCode.SELLER_CANCELLATION;
    default:
      return codeKr;
  }
};
export interface UpdateOrdersByCodeStatusRequest {
  orderIds: number[]; // 변경할 주문 코드 배열
  toStatus: OrderStatus; // 변경하려고 하는 주문 상태
  fromStatus: OrderStatus; // 변경 전 주문 상태
  orderCount: number; // 변경할 주문 건수
}

export interface UpdatePaymentDeadline {
  orderCode: string; // 주문 코드
  paymentDeadline: string; // 결제 기한 (YYYY-MM-DDTHH:mm:ssZ 형식)
}

export interface TableRow {
  values: Record<string, any>;
  rowSpan: Record<string, number>;
  original: {
    todo: IDetailTodo;
    order: IDetailOrder;
  };
}

// 취소, 환불 관련 인터페이스

export interface CancelToss {
  cancelItems: CancelOrderItem[];
  cancelReason: string;
  cancelType: CancelReasonCode;
  expectedCancelAmount: number;
  beforeStatus: OrderStatus;
}
export interface CancelOrderItem {
  id: number; // 주문 ID
  count: number; // 취소할 상품 개수
}

export interface BankCode {
  name: string; // 한글 은행명
  code: string; // 코드 (예: "39")
}

export const bankCodeList: BankCode[] = [
  { name: "경남은행", code: "39" },
  { name: "광주은행", code: "34" },
  { name: "단위농협(지역농축협)", code: "12" },
  { name: "부산은행", code: "32" },
  { name: "새마을금고", code: "45" },
  { name: "산림조합", code: "64" },
  { name: "신한은행", code: "88" },
  { name: "신협", code: "48" },
  { name: "씨티은행", code: "27" },
  { name: "우리은행", code: "20" },
  { name: "우체국예금보험", code: "71" },
  { name: "저축은행중앙회", code: "50" },
  { name: "전북은행", code: "37" },
  { name: "제주은행", code: "35" },
  { name: "카카오뱅크", code: "90" },
  { name: "케이뱅크", code: "89" },
  { name: "토스뱅크", code: "92" },
  { name: "하나은행", code: "81" },
  { name: "홍콩상하이은행", code: "54" },
  { name: "IBK기업은행", code: "03" },
  { name: "KB국민은행", code: "06" },
  { name: "iM뱅크(대구)", code: "31" },
  { name: "한국산업은행", code: "02" },
  { name: "NH농협은행", code: "11" },
  { name: "SC제일은행", code: "23" },
  { name: "Sh수협은행", code: "07" },
];

export interface PaymentRefundCalculate {
  cancelAmount: number;
  refundShippingFee: number;
  refundAddShippingFee: number;
  shippingFee: number;
}

export const cancelReasonLabelMap: Record<CancelReasonCode, string> = {
  [CancelReasonCode.BUYER_CHANGE_OF_MIND]: "구매자 변심",
  [CancelReasonCode.BUYER_ORDER_MISTAKE]: "구매자 주문실수",
  [CancelReasonCode.OUT_OF_STOCK]: "재고부족",
  [CancelReasonCode.PRODUCT_DAMAGE_OR_DEFECT]: "상품 파손 및 불량",
  [CancelReasonCode.WRONG_DELIVERY]: "오배송",
  [CancelReasonCode.SELLER_CANCELLATION]: "판매자 취소",
};
